import { forEach, isObject } from 'lodash';

export default {
  methods: {
    populateFormWithModel(modelName, formData = 'formData') {
      let model = isObject(modelName) ? modelName : this[modelName];
      if (model.parse) { model = model.parse(); }

      forEach(this[formData], (value, key) => {
        if (model[key]) this[formData][key] = model[key];
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/form_populator.js